export const KINERJA_PS_PERENCANAAN_PENGEMBANGAN_KOMPETENSI_DRAFT_STORAGE_KEY =
  'kinerja-ps-perencanaan-pengembangan-kompetensi-draft'

export const KINERJA_PS_PERENCANAAN_PENGEMBANGAN_KOMPETENSI_V2_DRAFT_STORAGE_KEY =
  'kinerja-ps-perencanaan-pengembangan-kompetensi-v2-draft'
